import { useState } from 'react'
import { Box, Stack } from '@mui/joy'
import ModalShowQRCode from '../ModalShowQRCode/ModalShowQRCode'

import { ProfileButtonMessage } from './ProfileButtons/ProfileButtonMessage'
import { ProfileButtonPhone } from './ProfileButtons/ProfileButtonPhone'
import { ModalMore } from './ProfileButtons/ModalMore'
import { ProfileButtonSettings } from './ProfileButtons/ProfileButtonSettings'
import { ProfileButtonNotifications } from './ProfileButtons/ProfileButtonNotifications'
import { ProfileButtonShare } from './ProfileButtons/ProfileButtonShare'
import { ProfileButtonSubs } from './ProfileButtons/ProfileButtonSubs'

function ProfileButtons({ username, id, firstName, lastName, avatar, side = false, itsme = false, restriction = {}, blocked = false, blockLoading, toggleBlock }) {
    const [shareOpen, setShareOpen] = useState(false);
    // Звонок недоступен, если это мой профиль, собеседник заблокирован,
    // приватность запрещает звонки, либо пока выполняется запрос блокировки
    // (blockLoading даёт мгновенный disable сразу при нажатии «Заблокировать»).
    const phoneDisabled = itsme || blocked || !restriction.canCall || blockLoading;

    const sxSide = {
        maxWidth: {
            lg: '90%',
            md: '90%',
            sm: '90%',
            xs: '100%',
        },
        display: 'flex',
        width: '100%',
        mx: 'auto',
        justifyContent: 'space-evenly',
        gap: 1,
        flexWrap: 'wrap',
        direction: 'row',
        mt: 2,
        mb: 3
    }

    return (
        <>
            <Box sx={{ ...sxSide }}>
                {side && <ProfileButtonPhone id={id} firstName={firstName} lastName={lastName} avatar={avatar} disabled={phoneDisabled} />}
                {!side && <ProfileButtonSettings />}
                {!side && <ProfileButtonNotifications />}
                <ProfileButtonMessage id={id} itsme={itsme} />
                {side && <ProfileButtonSubs id={id} itsme={itsme} />}
                <ProfileButtonShare setShareOpen={setShareOpen} />
                <ModalMore
                    setShareOpen={setShareOpen}
                    side={side}
                    id={id}
                    itsme={itsme}
                    blocked={blocked}
                    blockLoading={blockLoading}
                    toggleBlock={toggleBlock}
                />
            </Box>

            <ModalShowQRCode
                shareOpen={shareOpen}
                setShareOpen={setShareOpen}
                username={username}
                id={id}
            />
        </>
    );
}

export default ProfileButtons
